import { useCallback, useMemo } from 'react'
import { FeedbackRefuseReservationModalProps } from './FeedbackRefuseReservationModal.types'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { serviceBySpeciality } from '../../ConsultationCard/utils'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useHistory } from 'react-router-dom'
import { SPECIALTY } from '@/@types/specialty'
import { usePsyaliveProfessionalFullProfile } from '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsyaliveProfessionalFullProfile/PsyaliveProfessionalFullProfile.hook'

export const useFeedbackRefuseReservationModal = (
  props: FeedbackRefuseReservationModalProps,
) => {
  const { closeModal } = useModalContext()
  const { clinic } = useAuthContext()
  const { memoized } = usePsyaliveProfessionalFullProfile()

  const history = useHistory()

  const professionalServiceCanScheduleAttendance = useMemo(() => {
    return clinic?.services?.[serviceBySpeciality[props?.specialty]]
      ?.atendimentoAgendado
  }, [clinic?.services, props?.specialty])

  const handlePrimaryAction = useCallback(() => {
    closeModal()

    if (
      props?.specialty === SPECIALTY.PSYCHOLOGIST &&
      memoized?.showNewPsychologistSearch
    ) {
      history.push('/atendimento-agendado-psicologo/busca-profissional/v2')
      return
    }

    if (professionalServiceCanScheduleAttendance) {
      history.push(
        `/atendimento-agendado/especialidade/busca/${props?.specialty}`,
      )
    }
  }, [
    closeModal,
    history,
    memoized?.showNewPsychologistSearch,
    professionalServiceCanScheduleAttendance,
    props?.specialty,
  ])

  const handleCloseModal = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handlePrimaryActionLabel = useMemo(() => {
    if (professionalServiceCanScheduleAttendance) {
      return 'Quero agendar'
    }

    return 'Ok, entendi'
  }, [professionalServiceCanScheduleAttendance])

  return {
    actions: {
      handlePrimaryAction,
      handleCloseModal,
    },
    formatted: {
      primaryActionLabel: handlePrimaryActionLabel,
    },
    validations: {
      professionalServiceCanScheduleAttendance,
    },
  }
}
